module.exports = __webpack_public_path__ + "img/icon.aaad7a12.png";